module.exports = __webpack_public_path__ + "static/media/OpenSans-Regular.ac327c4d.woff";